let html = `<div class="files">
    <div class="files__left">
        <div class="full-start__poster selector">
            <img src="{img}" class="full-start__img" />
        </div>

        <div class="files__info">
            <div class="files__title">{title}</div>
            <div class="files__title-original">{original_title}</div>
        </div>
    </div>
    <div class="files__body">
        
    </div>
</div>`

export default html